import { gql } from '@apollo/client';

import { STANDARD_DELIVERY_DHC_REPORT_METRICS } from './fragments/standardDeliveryDHCReportMetrics';

export const GET_STANDARD_DELIVERY_DHC_REPORT_METRICS = gql`
  query GetStandardDeliveryDeviceHigherCategoryReportMetrics(
    $metricsOptions: MetricsInput!
    $filterOptions: StandardDeliveryDeviceHigherCategoryReportFiltersInput!
    $paginationOptions: PaginationOptions
    $sortOptions: SortOptions
    $searchTerm: String
  ) {
    getStandardDeliveryDeviceHigherCategoryReportMetrics(
      metricsOptions: $metricsOptions
      filterOptions: $filterOptions
      paginationOptions: $paginationOptions
      sortOptions: $sortOptions
      searchTerm: $searchTerm
    ) {
      edges {
        node {
          ...standardDeliveryDHCReportMetricsFragment
        }
      }
      total
    }
  }
  ${STANDARD_DELIVERY_DHC_REPORT_METRICS}
`;
